import { render, staticRenderFns } from "./ApproverSettingsList.vue?vue&type=template&id=306ef53e"
import script from "./ApproverSettingsList.vue?vue&type=script&lang=ts"
export * from "./ApproverSettingsList.vue?vue&type=script&lang=ts"
import style0 from "./ApproverSettingsList.vue?vue&type=style&index=0&id=306ef53e&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\808325\\Documents\\SsmlockEntryReqWebApp-IVC202512\\SsmlockEntryReqWebApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('306ef53e')) {
      api.createRecord('306ef53e', component.options)
    } else {
      api.reload('306ef53e', component.options)
    }
    module.hot.accept("./ApproverSettingsList.vue?vue&type=template&id=306ef53e", function () {
      api.rerender('306ef53e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/ApproverSettingsList/ApproverSettingsList.vue"
export default component.exports